<div class="cornersFormatContainer">
  <div
    v-for="corner in corners"
    v-if="corner.x>0"
    :class="'corner ' + corner.type + ' ' + corner.subtype "
    :style="getDimm(corner)"
  ></div>
</div>
